import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import * as moment from 'moment';

@Component({
  selector: 'period-picker',
  templateUrl: './period-picker.component.html',
  styleUrls: ['./period-picker.component.scss']
})

export class PeriodPickerComponent implements OnInit {
  @Output() periodChange = new EventEmitter<{ date_from: Date, date_to: Date, timePickerMode: string }>();
  @Input() input_picker_start_date: Date | null;
  @Input() input_picker_end_date: Date | null;
  @Input() input_picker_mode: string | null;
  date_from: Date;
  date_to: Date;

  picker_start_date: Date;
  picker_end_date: Date;
  customRange: boolean;

  selected: string;
  constructor() {
  }

  ngOnInit(): void {
    const today = new Date();
    const lastWeekDate = new Date(today)
    lastWeekDate.setDate(lastWeekDate.getDate() - 7);

    this.picker_start_date = this.input_picker_start_date || lastWeekDate;
    this.picker_end_date = this.input_picker_end_date || today;
    this.date_from = this.picker_start_date;
    this.date_to = this.picker_end_date;
    this.selected = this.input_picker_mode || 'year';
    if (this.selected === 'range') {
      this.customRange = true;
    }
  }

  onPeriodSelectionChange(event: MatSelectChange) {
    if (this.selected === 'range') {
      this.customRange = true;
    }
    else {
      this.customRange = false;
      this.updateDateRange(this.selected);
      this.emitRangeChange();
    }
  }
  updateDateRange(mode: string) {
    let todayMoment, endOfDay;

    switch (mode) {
      case 'forever':
        todayMoment = moment();
        endOfDay = todayMoment.clone();
        this.date_from = null;
        this.date_to = endOfDay.toDate();
        break;
      case 'year':
        todayMoment = moment();
        endOfDay = todayMoment.clone();
        this.date_from = endOfDay.clone().subtract(1, 'years').toDate();
        this.date_to = endOfDay.toDate();
        break;
      case 'semester':
        todayMoment = moment();
        endOfDay = todayMoment.clone();
        this.date_from = endOfDay.clone().subtract(6, 'months').toDate();
        this.date_to = endOfDay.toDate();
        break;
      case 'month':
        todayMoment = moment();
        endOfDay = todayMoment.clone();
        this.date_from = endOfDay.clone().subtract(1, 'months').toDate();
        this.date_to = endOfDay.toDate();
        break;
      case 'week':
        todayMoment = moment();
        endOfDay = todayMoment.clone();
        this.date_from = endOfDay.clone().subtract(7, 'days').toDate();
        this.date_to = endOfDay.toDate();
        break;
    }
  }
  updateDate(key: string, event: any){
     if(key === 'start_date'){
      this.date_from = moment(event.value).toDate();
     }
     if(key === 'end_date'){
      this.date_to = moment(event.value).endOf('day').toDate();
     }
     if(this.date_from > this.date_to){
      return;
     }
     this.emitRangeChange();
  }
  emitRangeChange() {
    this.periodChange.emit({ date_from: this.date_from, date_to: this.date_to, timePickerMode: this.selected });
  }
}
